"use client";
import { useEffect, useState } from "react";

const HubspotForm = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js-na2.hsforms.net/forms/embed/245326004.js";
    script.defer = true;

    script.onload = () => setLoaded(true);

    document.body.appendChild(script);
  }, []);

  return loaded ? (
    <div
      className="hs-form-frame"
      data-region="na2"
      data-form-id="478f544e-7d36-4088-9c7b-278e9489fcde"
      data-portal-id="245326004"
    ></div>
  ) : null;
};

export default HubspotForm;